module.exports = __webpack_public_path__ + "img/logo.28e37705.svg";